(() => {
  const root = document.querySelector(".ha-quiz");
  if (!root) return;

  const form = root.querySelector("[data-quiz]");
  const screens = [...form.querySelectorAll("[data-screen]")];
  const progressFill = root.querySelector("[data-progress]");
  const stepCounter = root.querySelector("[data-step-counter]");
  const backBtn = root.querySelector("[data-back]");
  const ctaUrl = root.dataset.ctaUrl || "/pages/quiz-result";
  // Screens past the loader = the payoff. Hide quiz chrome + use brand CTA.
  const RESULT_PHASE = new Set(["summary", "map", "bridge", "result"]);
  const applyChrome = (name) =>
    root.classList.toggle("ha-quiz--result-phase", RESULT_PHASE.has(name));
  const summaryLabels = {
    age: "Age range",
    frequency: "Bloating frequency",
    symptoms: "Recent symptoms",
    timing: "Bloating timing",
    diet: "Diet changes",
    regularity: "Digestion regularity",
    tried: "What you've tried",
    consistency: "Routine consistency",
    energy: "Energy & skin",
    goals: "Goals",
  };

  const total = screens.length;
  let index = 0;
  const history = [];
  let lastFocus = ""; // primary focus area, carried from summary into the offer

  // Funnel instrumentation: GA4/Elevar (dataLayer) + Triple Whale (TriplePixel) are
  // store-local and always fire. First-party beacon only fires if a Livera endpoint
  // is configured on the section (data-beacon-url) — never leaks to another brand's warehouse.
  const QUIZ = "livera-debloat";
  const BEACON_URL = root.dataset.beaconUrl || "";
  const sid = (function () {
    try {
      let v = sessionStorage.getItem("liv_quiz_sid");
      if (!v) {
        v = "q-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem("liv_quiz_sid", v);
      }
      return v;
    } catch (e) { return "q-" + Math.random().toString(36).slice(2, 14); }
  })();
  let beaconBuffer = [];

  function flushBeacon() {
    if (!BEACON_URL || !beaconBuffer.length) { beaconBuffer = []; return; }
    const events = beaconBuffer;
    beaconBuffer = [];
    try {
      const blob = new Blob(
        [JSON.stringify({ quiz: QUIZ, session_id: sid, events: events })],
        { type: "text/plain" } // simple request: no CORS preflight
      );
      if (navigator.sendBeacon) navigator.sendBeacon(BEACON_URL, blob);
    } catch (e) { /* never break the quiz */ }
  }

  function track(event, data) {
    try {
      const payload = Object.assign({ quiz: QUIZ }, data || {});
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: event }, payload));
      }
      if (typeof window.TriplePixel === "function") {
        window.TriplePixel("custom", event, payload);
      }
      beaconBuffer.push(Object.assign({ event: event, ts: Date.now() }, data || {}));
      if (
        beaconBuffer.length >= 12 ||
        event === "quiz_complete" ||
        event === "quiz_cta_click"
      ) {
        flushBeacon();
      }
    } catch (e) { /* analytics must never break the quiz */ }
  }

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") flushBeacon();
  });
  window.addEventListener("pagehide", flushBeacon);

  function setStep(next, push = true) {
    if (next < 0 || next >= screens.length) return;
    if (push && next !== index) history.push(index);
    screens[index].classList.remove("is-active");
    index = next;
    const screen = screens[index];
    screen.classList.add("is-active");

    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;

    window.scrollTo({ top: 0, behavior: "smooth" });

    const screenName = screen.dataset.screen;
    applyChrome(screenName);
    location.hash = screenName;
    track("quiz_step", { step: screenName, index: index + 1, total: total });

    if (screenName === "loader") runLoader(screen);
    if (screenName === "trust") initCarousel(screen);
    if (screenName === "summary") renderSummary(screen);
    if (screenName === "map") renderMap(screen);
    if (screenName === "bridge") renderBridge(screen);
    if (screenName === "result") {
      const focusEl = screen.querySelector("[data-offer-focus]");
      if (focusEl && lastFocus) {
        focusEl.textContent = "Your #1 focus: " + lastFocus;
        focusEl.hidden = false;
      }
      const cta = screen.querySelector("[data-cta]");
      if (cta) {
        cta.href = ctaUrl;
        if (!cta.dataset.trackBound) {
          cta.dataset.trackBound = "1";
          cta.addEventListener("click", function () {
            track("quiz_cta_click", { step: "result" });
          });
        }
      }
    }

    setTimeout(() => {
      const firstInput = screen.querySelector("input");
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 50);
  }

  function isAnswered(screen) {
    if (!screen.hasAttribute("data-required")) return true;
    const inputs = screen.querySelectorAll("input[type=radio], input[type=checkbox]");
    return [...inputs].some((i) => i.checked);
  }

  function runLoader(screen) {
    const items = [...screen.querySelectorAll("[data-step]")];
    const ms = parseInt(screen.dataset.autoAdvance || "4500", 10);
    const each = Math.max(400, Math.floor(ms / items.length));
    items.forEach((it) => it.classList.remove("is-active", "is-done"));
    items.forEach((item, i) => {
      setTimeout(() => {
        items.forEach((x) => x.classList.remove("is-active"));
        item.classList.add("is-active");
        if (i > 0) items[i - 1].classList.add("is-done");
      }, each * i);
    });
    setTimeout(() => {
      items.forEach((x) => x.classList.remove("is-active"));
      items.forEach((x) => x.classList.add("is-done"));
      setStep(index + 1);
    }, each * items.length);
  }

  function getAnswers() {
    const data = new FormData(form);
    const out = {};
    for (const [k, v] of data.entries()) {
      if (out[k] === undefined) out[k] = v;
      else if (Array.isArray(out[k])) out[k].push(v);
      else out[k] = [out[k], v];
    }
    return out;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
  }

  function listPhrase(a) {
    if (!a.length) return "the changes you described";
    if (a.length === 1) return a[0];
    if (a.length === 2) return a[0] + " and " + a[1];
    return a.slice(0, -1).join(", ") + ", and " + a[a.length - 1];
  }

  // Map each pain the user actually reports to what the formula does about it.
  // Plain, honest, and only triggered by answers they marked (no invented claims).
  function buildInsights(answers) {
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const timing = answers.timing || "";
    const diet = answers.diet || "";
    const regularity = answers.regularity || "";
    const energy = answers.energy || "";
    const frequency = answers.frequency || "";
    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    const catalog = [
      {
        on: symHas("bloating") || symHas("heavy") || symHas("gas") || timing === "After meals" || frequency === "Every day" || frequency === "Most days" || goalHas("bloating") || goalHas("flatter"),
        pain: symHas("bloating") ? "You bloat after normal meals" : "You feel heavy and tight by evening",
        action: "Ginger and turmeric settle your stomach and calm the inflammation behind the bloat — so you feel lighter, often within hours.",
        tone: "#ff6b09", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z",
      },
      {
        on: diet.indexOf("still bloated") > -1 || diet === "Somewhat" || symHas("water") || goalHas("lighter"),
        pain: diet.indexOf("still bloated") > -1 ? "You cut the trigger foods and you're still bloated" : "Your body struggles to break food down",
        action: "Milk thistle and dandelion clear the backlog your liver carries and get bile flowing, so your body actually breaks down what you eat.",
        tone: "#e65f00", icon: "M13 2L3 14h7l-1 8 10-12h-7l1-8z",
      },
      {
        on: regularity === "Irregular" || regularity === "Often constipated" || regularity === "Every couple days" || symHas("sluggish") || goalHas("regular"),
        pain: regularity === "Often constipated" ? "You're often backed up" : "Your digestion is slow and unpredictable",
        action: "The prebiotic fiber blend (inulin + pectin) feeds your good gut bacteria and keeps you regular — the exact dose is printed on the label.",
        tone: "#ff8a3d", icon: "M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z",
      },
      {
        on: energy.indexOf("Energy") > -1 || energy.indexOf("dull") > -1 || symHas("afternoon") || symHas("dull") || goalHas("energy") || goalHas("skin"),
        pain: energy.indexOf("dull") > -1 ? "Your skin looks dull and tired" : "Your energy dips in the afternoon",
        action: "When your liver clears the backlog, energy steadies and skin often follows — many notice it by week two.",
        tone: "#ffb782", icon: "M12 2l2.2 6.6L21 11l-6.8 2.4L12 20l-2.2-6.6L3 11l6.8-2.4z",
      },
    ];
    return catalog.filter((c) => c.on);
  }

  function renderMap(screen) {
    const answers = getAnswers();
    let insights = buildInsights(answers);
    if (insights.length < 2) {
      const fallback = [
        { pain: "Bloating that keeps coming back", action: "Ginger and turmeric settle your stomach and calm the inflammation behind the bloat, so you feel lighter.", tone: "#ff6b09", icon: "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z" },
        { pain: "A liver that can't keep up", action: "Milk thistle and dandelion clear the backlog your liver carries, so your body breaks down what you eat.", tone: "#e65f00", icon: "M13 2L3 14h7l-1 8 10-12h-7l1-8z" },
      ];
      fallback.forEach((f) => { if (insights.length < 2) insights.push(f); });
    }
    insights = insights.slice(0, 4);
    const list = screen.querySelector("[data-map-list]");
    if (!list) return;
    list.innerHTML = insights
      .map(
        (i) =>
          '<li class="ha-map__row" style="--tone:' + (i.tone || "#ff6b09") + '">' +
          '<span class="ha-map__icon" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 24 24" fill="none"><path d="' + (i.icon || "M12 2C8 6 6 9 6 13a6 6 0 0012 0c0-4-2-7-6-11z") + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<div class="ha-map__body">' +
          '<p class="ha-map__pain">' + escapeHtml(i.pain) + "</p>" +
          '<p class="ha-map__action"><span class="ha-map__arrow" aria-hidden="true">→</span>' + escapeHtml(i.action) + "</p>" +
          "</div>" +
          "</li>"
      )
      .join("");
  }

  function renderSummary(screen) {
    const answers = getAnswers();
    const arr = (k) => (answers[k] ? (Array.isArray(answers[k]) ? answers[k] : [answers[k]]) : []);

    // Subscores 0-100 (higher = better / less problem)
    const symptoms = arr("symptoms");
    const goals = arr("goals");
    const frequency = answers.frequency || "";
    const timing = answers.timing || "";
    const diet = answers.diet || "";
    const regularity = answers.regularity || "";
    const tried = answers.tried || "";
    const consistency = answers.consistency || "";
    const energyAns = answers.energy || "";

    const symHas = (s) => symptoms.some((x) => x.toLowerCase().includes(s));
    const goalHas = (s) => goals.some((x) => x.toLowerCase().includes(s));

    // Bloating & digestion
    let digestion = 70;
    if (frequency === "Every day") digestion -= 28;
    else if (frequency === "Most days") digestion -= 20;
    else if (frequency === "A few times a week") digestion -= 10;
    else if (frequency === "Only after certain foods") digestion -= 6;
    if (symHas("bloating")) digestion -= 15;
    if (symHas("heavy")) digestion -= 12;
    if (symHas("gas")) digestion -= 8;
    if (timing === "After meals" || timing === "Afternoon") digestion -= 8;

    // Liver load
    let liver = 70;
    if (diet.indexOf("still bloated") > -1) liver -= 25;
    else if (diet === "Somewhat") liver -= 12;
    if (symHas("water")) liver -= 12;
    if (symHas("sluggish")) liver -= 10;
    if (frequency === "Every day") liver -= 8;

    // Gut & regularity
    let gut = 70;
    if (regularity === "Often constipated") gut -= 28;
    else if (regularity === "Irregular") gut -= 25;
    else if (regularity === "Every couple days") gut -= 12;
    if (symHas("sluggish")) gut -= 12;
    if (tried === "Nothing yet") gut -= 8;

    // Energy & skin
    let glow = 70;
    if (energyAns.indexOf("Energy crashes and skin") > -1) glow -= 26;
    else if (energyAns === "Lower energy than before") glow -= 16;
    else if (energyAns === "Skin looks dull") glow -= 16;
    if (symHas("afternoon")) glow -= 12;
    if (symHas("dull")) glow -= 12;
    if (consistency === "I usually forget") glow -= 6;

    const clamp = (n) => Math.max(8, Math.min(95, Math.round(n)));
    digestion = clamp(digestion);
    liver = clamp(liver);
    gut = clamp(gut);
    glow = clamp(glow);

    const overall = Math.round((digestion + liver + gut + glow) / 4);

    const labelFor = (n) =>
      n < 30 ? "Low" :
      n < 55 ? "Fair" :
      n < 75 ? "Good" :
      "Strong";

    const badgeFor = (n) =>
      n < 25 ? "LOW" :
      n < 50 ? "LOW-MODERATE" :
      n < 70 ? "MODERATE" :
      n < 85 ? "GOOD" :
      "HIGH";

    screen.querySelector("[data-result-badge]").textContent = badgeFor(overall);
    const fill = screen.querySelector("[data-gauge-fill]");
    const marker = screen.querySelector("[data-gauge-marker]");
    if (fill) fill.style.width = overall + "%";
    if (marker) marker.style.left = overall + "%";

    // Each system card: short status word + a visual level meter (low = amber)
    const applyCard = (cardKey, meterKey, n) => {
      const val = screen.querySelector("[data-card='" + cardKey + "']");
      if (val) { val.textContent = labelFor(n); val.classList.toggle("ha-result__card-value--low", n < 40); }
      const fillEl = screen.querySelector("[data-meter='" + meterKey + "']");
      if (fillEl) { fillEl.style.width = Math.max(6, n) + "%"; fillEl.classList.toggle("ha-result__meter-fill--low", n < 40); }
    };
    applyCard("digestion", "digestion", digestion);
    applyCard("liver", "liver", liver);
    applyCard("gut", "gut", gut);
    applyCard("glow", "glow", glow);

    // Primary focus area = the weakest subscore (the root cause to address first)
    const focusMap = { digestion: "Bloating & digestion", liver: "Liver load", gut: "Gut & regularity", glow: "Energy & skin" };
    const subs = { digestion: digestion, liver: liver, gut: gut, glow: glow };
    const weakest = Object.keys(subs).reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    const focusEl = screen.querySelector("[data-primary-focus]");

    // Link the plan AND the primary focus to the stated GOALS. Falls back to the
    // weakest scored system if no goals were marked.
    const goalMap = {
      "Less bloating": { sys: "digestion", phrase: "feel less bloated" },
      "Flatter stomach": { sys: "digestion", phrase: "flatten your stomach" },
      "Regular digestion": { sys: "gut", phrase: "stay regular" },
      "Steady energy": { sys: "glow", phrase: "have steadier energy" },
      "Clearer skin": { sys: "glow", phrase: "clear up your skin" },
      "Feel lighter": { sys: "liver", phrase: "feel lighter" },
    };
    const goalList = arr("goals");
    const goalSystems = {};
    const goalPhrases = [];
    goalList.forEach((g) => {
      const m = goalMap[g];
      if (m) { goalSystems[m.sys] = true; if (goalPhrases.indexOf(m.phrase) === -1) goalPhrases.push(m.phrase); }
    });
    const hasGoals = goalPhrases.length > 0;

    // Primary focus = the goal area that needs the most support today
    // (weakest scored system among the goals).
    const scoredGoals = Object.keys(goalSystems).filter((s) => subs[s] !== undefined);
    let focusKey = weakest;
    if (scoredGoals.length) focusKey = scoredGoals.reduce((a, b) => (subs[a] <= subs[b] ? a : b));
    if (focusEl) focusEl.textContent = focusMap[focusKey];
    lastFocus = focusMap[focusKey];

    screen.querySelectorAll("[data-blend-system]").forEach((el) => {
      const match = hasGoals ? !!goalSystems[el.dataset.blendSystem] : el.dataset.blendSystem === weakest;
      el.classList.toggle("ha-plan__blend--focus", match);
      const tag = el.querySelector("[data-blend-tag]");
      if (tag) tag.hidden = !match;
    });
    const leadEl = screen.querySelector(".ha-plan__lead");
    if (leadEl && hasGoals) {
      leadEl.innerHTML = "You want to <strong>" + escapeHtml(listPhrase(goalPhrases.slice(0, 3))) + "</strong>. This plan targets it.";
    }

    // Build a phrase from the symptoms they actually marked, so the copy mirrors them.
    const shortMap = {
      "Bloating after normal meals": "bloating after meals",
      "Heavy or tight stomach": "a heavy, tight stomach",
      "Gas or discomfort": "gas and discomfort",
      "Sluggish or irregular digestion": "sluggish digestion",
      "Afternoon energy crashes": "afternoon energy crashes",
      "Dull or tired skin": "tired-looking skin",
      "Water retention or puffiness": "water retention",
    };
    const reported = symptoms.map((s) => shortMap[s] || s.toLowerCase()).slice(0, 3);
    if (reported.length < 2) {
      if (frequency === "Every day" && reported.indexOf("daily bloating") === -1) reported.push("daily bloating");
      if (diet.indexOf("still bloated") > -1 && reported.indexOf("bloat that won't quit") === -1) reported.push("bloat that won't quit");
    }
    const hasReported = reported.length > 0;
    const reportedPhrase = listPhrase(reported);

    // Personalize alert copy — names the signals they reported, score sets the tone.
    const title = screen.querySelector("[data-alert-title]");
    const copy = screen.querySelector("[data-alert-copy]");
    if (overall < 50) {
      title.textContent = "Your digestion needs more consistent support.";
      copy.textContent = hasReported
        ? "We trace " + reportedPhrase + " back to a liver and gut that can't keep up with what you eat."
        : "These signals point to a liver and gut that can't keep up with what you eat.";
    } else if (overall < 75) {
      title.textContent = "You're doing okay, with room to feel a lot lighter.";
      copy.textContent = "Daily support for your digestion and liver can ease the bloat within the first few weeks.";
    } else {
      title.textContent = "You're in a good place.";
      copy.textContent = "Steady daily support keeps your digestion even and the bloat from creeping back.";
    }

    try {
      sessionStorage.setItem(
        "liv_quiz_answers",
        JSON.stringify({ answers, focus: lastFocus, scores: { overall, digestion, liver, gut, glow } })
      );
    } catch (e) {}

    track("quiz_complete", {
      score: overall,
      badge: badgeFor(overall),
      focus: focusMap[weakest],
    });
  }

  // Projection: stamp a personalized ~3-week date on the bridge screen
  function renderBridge(screen) {
    const el = screen.querySelector("[data-projection-date]");
    if (!el) return;
    const d = new Date();
    d.setDate(d.getDate() + 21);
    el.textContent = d.toLocaleDateString("en-US", { month: "long", day: "numeric" });
  }

  // Carousel
  function initCarousel(screen) {
    const car = screen.querySelector("[data-carousel]");
    if (!car || car.dataset.inited === "1") return;
    car.dataset.inited = "1";
    const track = car.querySelector("[data-track]");
    const slides = track.children;
    const dots = [...car.querySelectorAll("[data-dot]")];
    const prev = car.querySelector("[data-prev]");
    const next = car.querySelector("[data-next-slide]");
    const autoplayMs = parseInt(car.dataset.autoplay || "0", 10);
    let i = 0;
    let timer = null;

    const render = () => {
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, idx) => d.classList.toggle("is-active", idx === i));
    };
    const go = (delta) => {
      i = (i + delta + slides.length) % slides.length;
      render();
      restart();
    };
    const restart = () => {
      if (!autoplayMs) return;
      clearInterval(timer);
      timer = setInterval(() => go(1), autoplayMs);
    };
    prev.addEventListener("click", (e) => { e.stopPropagation(); go(-1); });
    next.addEventListener("click", (e) => { e.stopPropagation(); go(1); });
    dots.forEach((d, idx) => d.addEventListener("click", (e) => { e.stopPropagation(); i = idx; render(); restart(); }));

    // touch swipe
    let startX = 0;
    track.addEventListener("touchstart", (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    render();
    restart();
  }

  // wire up "next" buttons
  form.addEventListener("click", (e) => {
    const next = e.target.closest("[data-next]");
    if (!next) return;
    e.preventDefault();
    const screen = screens[index];
    if (!isAnswered(screen)) {
      next.animate(
        [
          { transform: "translateX(0)" },
          { transform: "translateX(-6px)" },
          { transform: "translateX(6px)" },
          { transform: "translateX(0)" },
        ],
        { duration: 240 }
      );
      return;
    }
    setStep(index + 1);
  });

  // auto-advance for radio (single-select), not checkbox
  form.addEventListener("change", (e) => {
    const screen = screens[index];
    if (e.target.type === "radio" || e.target.type === "checkbox") {
      track("quiz_answer", {
        question: e.target.name,
        value: e.target.value,
        checked: e.target.checked !== false,
      });
    }
    if (e.target.type !== "radio") return;
    if (screen.hasAttribute("data-multi")) return;
    setTimeout(() => setStep(index + 1), 220);
  });

  // back
  backBtn.addEventListener("click", () => {
    if (!history.length) return;
    const prev = history.pop();
    screens[index].classList.remove("is-active");
    index = prev;
    screens[index].classList.add("is-active");
    const pct = Math.round(((index + 1) / total) * 100);
    progressFill.style.width = pct + "%";
    stepCounter.textContent = `${index + 1} / ${total}`;
    backBtn.hidden = history.length === 0;
    applyChrome(screens[index].dataset.screen);
    window.scrollTo({ top: 0, behavior: "smooth" });
    location.hash = screens[index].dataset.screen;
  });

  // initial
  progressFill.style.width = `${Math.round((1 / total) * 100)}%`;
  stepCounter.textContent = `1 / ${total}`;
  track("quiz_view", { step: "age", index: 1, total: total });

  // The global Rebuy app embed auto-opens SmartCart on hydration. CSS hides its
  // flyout on the quiz; this also calls hide() so any scroll-lock is released.
  // Scoped: this file only runs on the quiz. Belt-and-suspenders, low cost.
  function closeRebuy() {
    try { if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.hide === "function") Rebuy.SmartCart.hide(); } catch (e) {}
  }
  document.addEventListener("rebuy.ready", closeRebuy);
  [800, 2000, 4000, 7000].forEach(function (t) { setTimeout(closeRebuy, t); });
})();
